window.theme = window.theme || {};
window.Shopify = window.Shopify || {};

(function () {
	'use strict';

	theme.delegate = {
		on: function (event, callback, options) {
			if (!this.namespaces) // save the namespaces on the DOM element itself
				this.namespaces = {};

			this.namespaces[event] = callback;
			options = options || false;

			this.addEventListener(event.split('.')[0], callback, options);
			return this;
		},
		off: function (event) {
			if (!this.namespaces) { return }
			this.removeEventListener(event.split('.')[0], this.namespaces[event]);
			delete this.namespaces[event];
			return this;
		}
	};

	// Extend the DOM with these above custom methods
	window.on = Element.prototype.on = theme.delegate.on;
	window.off = Element.prototype.off = theme.delegate.off;

	theme.utils = {
		defaultTo: function (value, defaultValue) {
			return (value == null || value !== value) ? defaultValue : value
		},

		wrap: function (el, wrapper) {
			el.parentNode.insertBefore(wrapper, el);
			wrapper.appendChild(el);
		},

		debounce: function (wait, callback, immediate) {
			var timeout;
			return function () {
				var context = this, args = arguments;
				var later = function () {
					timeout = null;
					if (!immediate) callback.apply(context, args);
				};
				var callNow = immediate && !timeout;
				clearTimeout(timeout);
				timeout = setTimeout(later, wait);
				if (callNow) callback.apply(context, args);
			}
		},

		throttle: function (limit, callback) {
			var waiting = false;
			return function () {
				if (!waiting) {
					callback.apply(this, arguments);
					waiting = true;
					setTimeout(function () {
						waiting = false;
					}, limit);
				}
			}
		},

		prepareTransition: function (el, callback) {
			el.addEventListener('transitionend', removeClass);

			function removeClass(evt) {
				el.classList.remove('is-transitioning');
				el.removeEventListener('transitionend', removeClass);
			}

			el.classList.add('is-transitioning');
			el.offsetWidth; // check offsetWidth to force the style rendering

			if (typeof callback === 'function') {
				callback();
			}
		},

		// _.compact from lodash
		// Creates an array with all falsey values removed. The values `false`, `null`,
		// `0`, `""`, `undefined`, and `NaN` are falsey.
		// _.compact([0, 1, false, 2, '', 3]);
		// => [1, 2, 3]
		compact: function (array) {
			var index = -1,
				length = array == null ? 0 : array.length,
				resIndex = 0,
				result = [];

			while (++index < length) {
				var value = array[index];
				if (value) {
					result[resIndex++] = value;
				}
			}
			return result;
		},

		serialize: function (form) {
			var arr = [];
			Array.prototype.slice.call(form.elements).forEach(function (field) {
				if (
					!field.name ||
					field.disabled ||
					['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
				)
					return;
				if (field.type === 'select-multiple') {
					Array.prototype.slice.call(field.options).forEach(function (option) {
						if (!option.selected) return;
						arr.push(
							encodeURIComponent(field.name) +
							'=' +
							encodeURIComponent(option.value)
						);
					});
					return;
				}
				if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked)
					return;
				arr.push(
					encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)
				);
			});
			return arr.join('&');
		}
	};

	theme.a11y = {
		trapFocus: function (options) {
			var eventsName = {
				focusin: options.namespace ? 'focusin.' + options.namespace : 'focusin',
				focusout: options.namespace
					? 'focusout.' + options.namespace
					: 'focusout',
				keydown: options.namespace
					? 'keydown.' + options.namespace
					: 'keydown.handleFocus'
			};

			// Get every possible visible focusable element
			var focusableEls = options.container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])');
			var elArray = [].slice.call(focusableEls);
			var focusableElements = elArray.filter(el => el.offsetParent !== null);

			var firstFocusable = focusableElements[0];
			var lastFocusable = focusableElements[focusableElements.length - 1];

			if (!options.elementToFocus) {
				options.elementToFocus = options.container;
			}

			options.container.setAttribute('tabindex', '-1');
			options.elementToFocus.focus();

			document.documentElement.off('focusin');
			document.documentElement.on(eventsName.focusout, function () {
				document.documentElement.off(eventsName.keydown);
			});

			document.documentElement.on(eventsName.focusin, function (evt) {
				if (evt.target !== lastFocusable && evt.target !== firstFocusable) return;

				document.documentElement.on(eventsName.keydown, function (evt) {
					_manageFocus(evt);
				});
			});

			function _manageFocus(evt) {
				if (evt.keyCode !== 9) return;
				/**
				 * On the first focusable element and tab backward,
				 * focus the last element
				 */
				if (evt.target === firstFocusable && evt.shiftKey) {
					evt.preventDefault();
					lastFocusable.focus();
				}
			}
		},
		removeTrapFocus: function (options) {
			var eventName = options.namespace
				? 'focusin.' + options.namespace
				: 'focusin';

			if (options.container) {
				options.container.removeAttribute('tabindex');
			}

			document.documentElement.off(eventName);
		},

		lockMobileScrolling: function (namespace, element) {
			var el = element ? element : document.documentElement;
			document.documentElement.classList.add('lock-scroll');
			el.on('touchmove' + namespace, function () {
				return true;
			});
		},

		unlockMobileScrolling: function (namespace, element) {
			document.documentElement.classList.remove('lock-scroll');
			var el = element ? element : document.documentElement;
			el.off('touchmove' + namespace);
		}
	};

	// Add class when tab key starts being used to show outlines
	document.documentElement.on('keyup.tab', function (evt) {
		if (evt.keyCode === 9) {
			document.documentElement.classList.add('tab-outline');
			document.documentElement.off('keyup.tab');
		}
	});

	/*============================================================================
		Collection JS sets up grids of products, even if not
		on the collection template.
		When on the collection template, also setup sorting, filters, grid options
		==============================================================================*/
	theme.Collection = (function () {
		var isAnimating = false;

		var selectors = {
			sortSelect: '#SortBy',
			sortBtn: '.filter-sort',

			colorSwatchImage: '.grid-product__color-image',
			colorSwatch: '.color-swatch--with-image',

			viewChange: '.grid-view-btn',
			productGrid: '.product-grid',

			collectionGrid: '.collection-grid__wrapper',
			sidebar: '#CollectionSidebar',
			activeTagList: '.tag-list--active-tags',
			tags: '.tag-list input',
			activeTags: '.tag-list a',
			tagsForm: '.filter-form',
			filterBar: '.collection-filter',
			priceRange: '.price-range',
			trigger: '.collapsible-trigger',

			filters: '.filter-wrapper',
			sidebarWrapper: '#CollectionSidebarFilterWrap',
			inlineWrapper: '#CollectionInlineFilterWrap',
		};

		var config = {
			mobileFiltersInPlace: false
		};

		var classes = {
			activeTag: 'tag--active',
			removeTagParent: 'tag--remove',
			collapsibleContent: 'collapsible-content',
			isOpen: 'is-open',
		};

		function Collection(container) {
			this.container = container;
			this.containerId = container.id;
			this.sectionId = container.getAttribute('data-section-id');
			this.namespace = '.collection-' + this.sectionId;
			this.isCollectionTemplate = this.container.dataset.collectionTemplate;
			this.ajaxRenderer = new theme.AjaxRenderer({
				sections: [{ sectionId: this.sectionId, nodeId: 'CollectionAjaxContent' }],
				onReplace: this.onReplaceAjaxContent.bind(this),
			});

			this.init(container);
		}

		Collection.prototype = Object.assign({}, Collection.prototype, {
			init: function (container) {
				config.mobileFiltersInPlace = false;

				// If container not set, section has been reinitialized.
				// Update this.container to refreshed DOM element
				if (!container) {
					this.container = document.getElementById(this.containerId);
				}

				// console.log("dataset", this.container.dataset, this.isCollectionTemplate)

				if (this.isCollectionTemplate) {
					// this.cloneFiltersOnMobile();
					this.initSort();
					this.initFilters();
					this.initPriceRange();
					this.initGridOptions();
					this.initProductsPerPage();
					this.initReadMore();

					// Has to init after the Collection JS because cloneFiltersOnMobile
					// this.sidebar = new theme.CollectionSidebar();
				}

				this.quickAdd = new theme.QuickAdd(this.container);
				this.quickShop = new theme.QuickShop(this.container);

				this.colorImages = this.container.querySelectorAll(selectors.colorSwatchImage);
				if (this.colorImages.length) {
					this.swatches = this.container.querySelectorAll(selectors.colorSwatch);
					this.colorSwatchHovering();
				}
			},

			/*============================================================================
				Collection sorting
			==============================================================================*/
			initSort: function () {
				this.queryParams = new URLSearchParams(window.location.search);
				this.sortSelect = document.querySelector(selectors.sortSelect);
				this.sortBtns = document.querySelectorAll(selectors.sortBtn);

				if (this.sortSelect) {
					this.defaultSort = this.getDefaultSortValue();
					this.sortSelect.on('change' + this.namespace, () => { this.onSortChange() });
				}

				if (this.sortBtns.length) {
					this.sortBtns.forEach(btn => {
						btn.addEventListener('click', function () {
							document.dispatchEvent(new Event('filter:selected'));
							const sortValue = btn.dataset.value;
							this.onSortChange(sortValue);
						}.bind(this));
					});
				}
			},

			/*============================================================================
				Collection Description Read more
			==============================================================================*/
			initReadMore: function () {
				const readMoreBtn = document.querySelector('[data-read-more]');
				const readMoreContainer = document.querySelector('[data-collection-desc-hide]');
				if (!readMoreBtn || !readMoreContainer) return;

				if (readMoreContainer.scrollHeight <= readMoreContainer.clientHeight) {
					readMoreBtn.style.display = 'none';
				} else {
					readMoreContainer.style.height = '120px';
					readMoreContainer.style.maxHeight = 'none';
					readMoreBtn.addEventListener('click', function (e) {
						e.preventDefault();
						readMoreContainer.classList.toggle('is-expanded');
						readMoreContainer.style.height = readMoreContainer.classList.contains('is-expanded') ? `${readMoreContainer.scrollHeight}px` : '120px';
						readMoreBtn.innerText = readMoreContainer.classList.contains('is-expanded') ? 'Read less' : 'Read more';
					});
				}
			},

			getSortValue: function () {
				return this.sortSelect.value || this.defaultSort;
			},

			getDefaultSortValue: function () {
				return this.sortSelect.getAttribute('data-default-sortby');
			},

			onSortChange: function (sortValue = null) {
				this.queryParams = new URLSearchParams(window.location.search);

				if (sortValue) {
					this.queryParams.set('sort_by', sortValue);
				} else {
					this.queryParams.set('sort_by', this.getSortValue());
				}

				this.queryParams.delete('page'); // Delete if it exists
				window.location.search = this.queryParams.toString();
			},

			/*============================================================================
				Color swatch hovering
			==============================================================================*/
			colorSwatchHovering: function () {
				this.swatches.forEach(swatch => {
					swatch.addEventListener('mouseenter', function () {
						this.setActiveColorImage(swatch);
					}.bind(this));

					swatch.addEventListener('touchstart', function (evt) {
						evt.preventDefault();
						this.setActiveColorImage(swatch);
					}.bind(this), { passive: true });
				});
			},

			setActiveColorImage: function (swatch) {
				var id = swatch.dataset.variantId;
				var image = swatch.dataset.variantImage;

				// Unset all active swatch images
				this.colorImages.forEach(el => {
					el.classList.remove('is-active');
				});

				// Unset all active swatches
				this.swatches.forEach(el => {
					el.classList.remove('is-active');
				});

				// Set active image and swatch
				var imageEl = this.container.querySelector('.grid-product__color-image--' + id);
				imageEl.style.backgroundImage = 'url(' + image + ')';
				imageEl.classList.add('is-active');
				swatch.classList.add('is-active');

				// Update product grid item href with variant URL
				var variantUrl = swatch.dataset.url;
				var gridItem = swatch.closest('.grid-item__link');
				gridItem.setAttribute('href', variantUrl);
			},

			/*============================================================================
				Grid view options
			==============================================================================*/
			initGridOptions: function () {
				var grid = this.container.querySelector(selectors.productGrid);
				var viewBtns = this.container.querySelectorAll(selectors.viewChange);
				this.container.querySelectorAll(selectors.viewChange).forEach(btn => {
					btn.addEventListener('click', function () {
						viewBtns.forEach(el => {
							el.classList.remove('is-active');
						});
						btn.classList.add('is-active');
						var newView = btn.dataset.view;
						grid.dataset.view = newView;

						// Set as cart attribute so we can access in liquid
						theme.cart.updateAttribute('product_view', newView);

						// Trigger resize to update layzloaded images
						window.dispatchEvent(new Event('resize'));
					});
				});
			},

			/*====================
				Collection filters
			====================*/
			initFilters: function () {
				var tags = document.querySelectorAll(selectors.tags);

				if (!tags.length) {
					return;
				}

				document.addEventListener('matchSmall', this.cloneFiltersOnMobile.bind(this));
				this.bindBackButton();

				// Set mobile top value for filters if sticky header enabled
				if (theme.config.stickyHeader) {
					this.setFilterStickyPosition();

					document.addEventListener('headerStickyChange', theme.utils.debounce(500, this.setFilterStickyPosition));
					window.on('resize', theme.utils.debounce(500, this.setFilterStickyPosition));
				}

				document.querySelectorAll(selectors.activeTags).forEach(tag => {
					tag.addEventListener('click', this.onTagClick.bind(this));
				});

				document.querySelectorAll(selectors.tagsForm).forEach(form => {
					form.addEventListener('input', this.onFormSubmit.bind(this));
				});
			},

			initPriceRange: function () {
				const priceRangeEls = document.querySelectorAll(selectors.priceRange)
				priceRangeEls.forEach((el) => new theme.PriceRange(el, {
					// onChange passes in formData
					onChange: this.renderFromFormData.bind(this),
				}));
			},

			cloneFiltersOnMobile: function () {
				if (config.mobileFiltersInPlace) {
					return;
				}

				var sidebarWrapper = document.querySelector(selectors.sidebarWrapper);
				if (!sidebarWrapper) {
					return;
				}
				var filters = sidebarWrapper.querySelector(selectors.filters).cloneNode(true);

				var inlineWrapper = document.querySelector(selectors.inlineWrapper);

				inlineWrapper.innerHTML = '';
				inlineWrapper.append(filters);

				// Update collapsible JS
				theme.collapsibles.init(inlineWrapper);

				config.mobileFiltersInPlace = true;
			},

			renderActiveTag: function (parent, el) {
				const textEl = parent.querySelector('.tag__text');

				if (parent.classList.contains(classes.activeTag)) {
					parent.classList.remove(classes.activeTag);
				} else {
					parent.classList.add(classes.activeTag);

					// If adding a tag, show new tag right away.
					// Otherwise, remove it before ajax finishes
					if (el.closest('li').classList.contains(classes.removeTagParent)) {
						parent.remove();
					} else {
						// Append new tag in both drawer and sidebar
						document.querySelectorAll(selectors.activeTagList).forEach(list => {
							const newTag = document.createElement('li');
							const newTagLink = document.createElement('a');
							newTag.classList.add('tag', 'tag--remove');
							newTagLink.classList.add('btn', 'btn--small');
							newTagLink.innerText = textEl.innerText;
							newTag.appendChild(newTagLink);

							list.appendChild(newTag);
						});
					}
				}
			},

			onTagClick: function (evt) {
				const el = evt.currentTarget;

				document.dispatchEvent(new Event('filter:selected'));

				// Do not ajax-load collection links
				if (el.classList.contains('no-ajax')) {
					return;
				}

				evt.preventDefault();
				if (isAnimating) {
					return;
				}

				isAnimating = true;

				const parent = el.parentNode;
				const newUrl = new URL(el.href);

				this.renderActiveTag(parent, el);
				this.updateScroll(true);
				this.startLoading();
				this.renderCollectionPage(newUrl.searchParams);
			},

			onFormSubmit: function (evt) {
				const el = evt.target;

				document.dispatchEvent(new Event('filter:selected'));

				// Do not ajax-load collection links
				if (el.classList.contains('no-ajax')) {
					return;
				}

				evt.preventDefault();
				if (isAnimating) {
					return;
				}

				isAnimating = true;

				const parent = el.closest('li');
				const formEl = el.closest('form');
				const formData = new FormData(formEl);

				this.renderActiveTag(parent, el);
				this.updateScroll(true);
				this.startLoading();
				this.renderFromFormData(formData);
			},

			onReplaceAjaxContent: function (newDom, section) {
				const openCollapsibleIds = this.fetchOpenCollasibleFilters();

				openCollapsibleIds.forEach(selector => {
					newDom
						.querySelectorAll(`[data-collapsible-id=${selector}]`)
						.forEach(this.openCollapsible);
				});

				var newContentEl = newDom.getElementById(section.nodeId);
				if (!newContentEl) {
					return;
				}

				document.getElementById(section.nodeId).innerHTML = newContentEl.innerHTML;

				// Update references to new product count in collection
				var page = document.getElementById(section.nodeId);
				var countEl = page.querySelector('.collection-filter__item--count');
				if (countEl) {
					var count = countEl.innerText;
					document.querySelectorAll('[data-collection-count]').forEach(el => {
						el.innerText = count;
					});
				}

			},

			renderFromFormData: function (formData) {
				const searchParams = new URLSearchParams(formData);
				this.renderCollectionPage(searchParams);
			},

			renderCollectionPage: function (searchParams, updateURLHash = true) {
				let productsPerPage = new URLSearchParams(window.location.search).get('view') ?? 12;

				this.ajaxRenderer
					.renderPage(window.location.pathname, searchParams, updateURLHash)
					.then(() => {
						// console.log(theme)
						theme.sections.reinit('collection-template');
						this.updateScroll(false);
						this.initPriceRange();
						this.initProductsPerPage(productsPerPage);
						theme.reinitProductGridItem();

						document.dispatchEvent(new CustomEvent('collection:reloaded'));

						isAnimating = false;
					});
			},

			updateScroll: function (animate) {
				var scrollTo = document.getElementById('CollectionAjaxContent').offsetTop;

				// Scroll below the sticky header
				if (theme.config.stickyHeader) {
					scrollTo = scrollTo - document.querySelector('#SiteHeader').offsetHeight;
				}

				if (!theme.config.bpSmall) {
					scrollTo -= 10;
				}

				if (animate) {
					window.scrollTo({ top: scrollTo, behavior: 'smooth' });
				} else {
					window.scrollTo({ top: scrollTo });
				}
			},

			bindBackButton: function () {
				// Ajax page on back button
				window.off('popstate' + this.namespace);
				window.on('popstate' + this.namespace, function (state) {
					if (state) {
						const newUrl = new URL(window.location.href);
						this.renderCollectionPage(newUrl.searchParams, false);
					}
				}.bind(this));
			},

			fetchOpenCollasibleFilters: function () {
				const openDesktopCollapsible = Array.from(
					document.querySelectorAll(
						`${selectors.sidebar} ${selectors.trigger}.${classes.isOpen}`
					)
				);

				const openMobileCollapsible = Array.from(
					document.querySelectorAll(
						`${selectors.inlineWrapper} ${selectors.trigger}.${classes.isOpen}`
					)
				);

				return [
					...openDesktopCollapsible,
					...openMobileCollapsible,
				].map(trigger => trigger.dataset.collapsibleId);
			},

			openCollapsible: function (el) {
				if (el.classList.contains(classes.collapsibleContent)) {
					el.style.height = 'auto';
				}

				el.classList.add(classes.isOpen);
			},

			/*============================================================================
				Misc collection page helpers
			==============================================================================*/
			setFilterStickyPosition: function () {
				var headerHeight = document.querySelector('.site-header').offsetHeight - 1;
				document.querySelector(selectors.filterBar).style.top = headerHeight + 'px';

				// Also update top position of sticky sidebar
				var stickySidebar = document.querySelector('.grid__item--sidebar');
				if (stickySidebar) {
					stickySidebar.style.top = headerHeight + 30 + 'px';
				}
			},

			startLoading: function () {
				document.querySelector(selectors.collectionGrid).classList.add('unload');
			},

			forceReload: function () {
				this.init(this.container);
			},

			initProductsPerPage: function (_productsPerPage) {
				let url = new URL(window.location.href);

				let productsPerPage = url.searchParams.get('view') ?? _productsPerPage;

				if (productsPerPage && document.querySelector(`[data-products-per-page="${productsPerPage}"]`)) {
					document.querySelector('[data-products-per-page].active').classList.remove('active')

					document.querySelector(`[data-products-per-page="${productsPerPage}"]`).classList.add('active')
				}

				document.querySelectorAll('[data-products-per-page]').forEach(function (el) {
					el.addEventListener('click', function (e) {
						e.preventDefault();

						url.searchParams.set('view', el.dataset.productsPerPage);
						url.searchParams.delete('page'); // go back to page 1

						//load set url
						window.location.href = url;
					});
				});
			}
		});

		return Collection;
	})();

	theme.reinitProductGridItem = function (scope) {
		// Refresh reviews app
		// if (window.SPR) { SPR.initDomEls(); SPR.loadBadges() }
		// console.log("reinitProductGridItem", SPR)

		// Re-hook up collapsible box triggers
		// theme.collapsibles.init();
	};


	/**
	 * Ajax Renderer
	 * -----------------------------------------------------------------------------
	 * Render sections without reloading the page.
	 * @param {Object[]} sections - The section to update on render.
	 * @param {string} sections[].sectionId - The ID of the section from Shopify.
	 * @param {string} sections[].nodeId - The ID of the DOM node to replace.
	 * @param {Function} sections[].onReplace (optional) - The custom render function.
	 * @param {boolean} debug - Output logs to console for debugging.
	 *
	 */
	theme.AjaxRenderer = (function () {
		function AjaxRenderer({ sections, onReplace, debug } = {}) {
			this.sections = sections || [];
			this.cachedSections = [];
			this.onReplace = onReplace;
			this.debug = Boolean(debug);
		}

		AjaxRenderer.prototype = Object.assign({}, AjaxRenderer.prototype, {
			renderPage: function (basePath, newParams, updateURLHash = true) {
				const currentParams = new URLSearchParams(window.location.search);
				const updatedParams = this.getUpdatedParams(currentParams, newParams)

				const sectionRenders = this.sections.map(section => {

					const url = `${basePath}?section_id=${section.sectionId}&${updatedParams.toString()}`;
					const cachedSectionUrl = cachedSection => cachedSection.url === url;

					return this.cachedSections.some(cachedSectionUrl)
						? this.renderSectionFromCache(cachedSectionUrl, section)
						: this.renderSectionFromFetch(url, section);
				});

				if (updateURLHash) this.updateURLHash(updatedParams);

				return Promise.all(sectionRenders);
			},

			renderSectionFromCache: function (url, section) {
				const cachedSection = this.cachedSections.find(url);

				this.log(`[AjaxRenderer] rendering from cache: url=${cachedSection.url}`);
				this.renderSection(cachedSection.html, section);
				return Promise.resolve(section);
			},

			renderSectionFromFetch: function (url, section) {
				this.log(`[AjaxRenderer] redering from fetch: url=${url}`);

				return new Promise((resolve, reject) => {
					fetch(url)
						.then(response => response.text())
						.then(responseText => {
							const html = responseText;
							this.cachedSections = [...this.cachedSections, { html, url }];
							this.renderSection(html, section);
							resolve(section);
						})
						.catch(err => reject(err));
				});
			},

			renderSection: function (html, section) {
				this.log(
					`[AjaxRenderer] rendering section: section=${JSON.stringify(section)}`,
				);

				const newDom = new DOMParser().parseFromString(html, 'text/html');
				if (this.onReplace) {
					this.onReplace(newDom, section);
				} else {
					if (typeof section.nodeId === 'string') {
						var newContentEl = newDom.getElementById(section.nodeId);
						if (!newContentEl) {
							return;
						}

						document.getElementById(section.nodeId).innerHTML =
							newContentEl.innerHTML;
					} else {
						section.nodeId.forEach(id => {
							document.getElementById(id).innerHTML =
								newDom.getElementById(id).innerHTML;
						});
					}
				}

				return section;
			},

			getUpdatedParams: function (currentParams, newParams) {
				const clone = new URLSearchParams(currentParams);
				const preservedParams = ['sort_by', 'q', 'options[prefix]', 'type'];

				// Find what params need to be removed
				// delete happens first as we cannot specify keys based off of values
				for (const [key, value] of clone.entries()) {
					if (!newParams.getAll(key).includes(value) && !preservedParams.includes(key)) {
						clone.delete(key);
					};
				}

				// Find what params need to be added
				for (const [key, value] of newParams.entries()) {
					if (!clone.getAll(key).includes(value) && value !== '') {
						clone.append(key, value);
					}
				}

				return clone;
			},

			updateURLHash: function (searchParams) {
				history.pushState(
					{},
					'',
					`${window.location.pathname}${searchParams && '?'.concat(searchParams)
					}`,
				);
			},

			log: function (...args) {
				if (this.debug) {
					console.log(...args);
				}
			},
		});

		return AjaxRenderer;
	})();

	/*============================================================================
		QuickAdd
		- Setup quick add buttons/forms on a product grid item
	==============================================================================*/
	theme.QuickAdd = (function () {
		var selectors = {
			quickAddBtn: '.js-quick-add-btn',
			quickAddForm: '.js-quick-add-form',
			quickAddHolder: '#QuickAddHolder'
		};

		var modalInitailized = false;
		var modal;

		function QuickAdd(container) {
			if (!container) {
				return;
			}

			if (!theme.settings.quickAdd) {
				return;
			}

			this.container = container;
			this.init();
		}

		QuickAdd.prototype = Object.assign({}, QuickAdd.prototype, {
			init: function () {
				// When a single variant, auto add it to cart
				var quickAddBtns = this.container.querySelectorAll(selectors.quickAddBtn);
				if (quickAddBtns) {
					quickAddBtns.forEach(btn => {
						btn.addEventListener('click', this.addToCart.bind(this));
					});
				}

				// Button loads form when 1+ variants
				var quickAddForms = this.container.querySelectorAll(selectors.quickAddForm);

				if (quickAddForms.length) {
					this.quickAddHolder = document.querySelector(
						selectors.quickAddHolder);
					if (!modalInitailized) {
						modal = new theme.Modals('QuickAddModal', 'quick-add');
						modalInitailized = true;

						// Empty cart form when closed
						document.addEventListener('modalClose.QuickAddModal', function () {
							setTimeout(function () {
								this.quickAddHolder.innerHTML = '';
							}.bind(this), 350);
						}.bind(this));
					}

					quickAddForms.forEach(btn => {
						btn.addEventListener('click', this.loadQuickAddForm.bind(this));
					});
				}
			},

			addToCart: function (evt) {
				var btn = evt.currentTarget;
				var visibleBtn = btn.querySelector('.btn');
				visibleBtn.classList.add('btn--loading');
				var id = btn.dataset.id;

				var data = {
					'items': [{
						'id': id,
						'quantity': 1
					}]
				};

				fetch(theme.routes.cartAdd, {
					method: 'POST',
					body: JSON.stringify(data),
					credentials: 'same-origin',
					headers: {
						'Content-Type': 'application/json'
					}
				})
					.then(response => response.json())
					.then(function (data) {
						if (data.status === 422 || data.status === 'bad_request') {
						} else {
							var product = data;
							document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
								detail: {
									product: product,
									addToCartBtn: btn
								}
							}));
						}

						visibleBtn.classList.remove('btn--loading');
					}.bind(this));
			},

			loadQuickAddForm: function (evt) {
				this.quickAddHolder.innerHTML = '';

				var btn = evt.currentTarget;
				var gridItem = evt.currentTarget.closest('.grid-product');
				var handle = gridItem.getAttribute('data-product-handle');
				var prodId = gridItem.getAttribute('data-product-id');

				var url = theme.routes.home + '/products/' + handle + '?view=form';

				// remove double `/` in case shop might have /en or language in URL
				url = url.replace('//', '/');

				fetch(url).then(function (response) {
					return response.text();
				}).then(function (html) {
					var parser = new DOMParser();
					var doc = parser.parseFromString(html, 'text/html');
					var div = doc.querySelector('.product-section[data-product-handle="' + handle + '"]');

					this.quickAddHolder.append(div);

					// Register product template inside modal
					theme.sections.register('product', theme.Product, this.quickAddHolder);

					if (Shopify && Shopify.PaymentButton) {
						Shopify.PaymentButton.init();
					}

					window.dispatchEvent(new CustomEvent('quickadd:loaded:' + prodId));

					document.dispatchEvent(new CustomEvent('quickadd:loaded', {
						detail: {
							productId: prodId,
							handle: handle
						}
					}));

					modal.open();
				}.bind(this));
			}
		});

		return QuickAdd;
	})();

	/*============================================================================
		QuickShop
		- Setup quick shop modals anywhere a product grid item exists
		- Duplicate product modals will be condensed down to one workable one
	==============================================================================*/
	theme.QuickShop = (function () {
		var loadedIds = [];
		var selectors = {
			product: '.grid-product',
			triggers: '.quick-product__btn',
			modalContainer: '#ProductModals'
		};

		function QuickShop(container) {
			if (!theme.settings.quickView) {
				return;
			}

			this.container = container;
			this.init();
		}

		function getData(el) {
			return {
				id: el.dataset.productId,
				handle: el.dataset.productHandle
			}
		}

		function productMouseover(evt) {
			var el = evt.currentTarget;

			// No quick view on mobile breakpoint
			if (theme.config.bpSmall) {
				return;
			}

			// No product or onboarding content, bail
			if (!el || !el.dataset.productId) {
				return;
			}

			var data = getData(el);
			el.removeEventListener('mouseover', productMouseover);

			preloadProductModal(data);
		}

		function preloadProductModal(data) {
			var modals = document.querySelectorAll('.modal--quick-shop[data-product-id="' + data.id + '"]');

			if (!modals.length) {
				return;
			}

			// If already loaded, no need to refetch info
			if (loadedIds.indexOf(data.id) > -1) {
				removeDuplicateModals(modals);
				enableTriggers(data);
			} else {
				// Move modal to storage element so animations work regardless
				// of where original markup is. Will also remove duplicates.
				moveModal(modals);

				var holder = document.getElementById('QuickShopHolder-' + data.handle);
				var url = theme.routes.home + '/products/' + data.handle + '?view=modal';

				// remove double `/` in case shop might have /en or language in URL
				url = url.replace('//', '/');

				fetch(url).then(function (response) {
					return response.text();
				}).then(function (html) {
					// Convert the HTML string into a document object
					var parser = new DOMParser();
					var doc = parser.parseFromString(html, 'text/html');
					var div = doc.querySelector('.product-section[data-product-handle="' + data.handle + '"]');

					if (!holder) {
						return;
					}

					holder.append(div);

					// Register product template inside quick view
					theme.sections.register('product', theme.Product, holder);

					// Register collapsible elements
					theme.collapsibles.init();

					// Register potential video modal links (when video has sound)
					theme.videoModal();

					// There may be multiple triggers for the same modal, so enable them all
					enableTriggers(data);
				});
			}

			// Add ID to global array so we don't double-load
			loadedIds.push(data.id);
		}

		function moveModal(modals) {
			var el = modals[0];
			if (!el) {
				return;
			}

			// If we have multiple modals, keep the first and remove all the rest
			if (modals.length > 1) {
				modals.forEach(function (m, i) {
					if (i > 0) {
						m.remove();
					}
				})
			}

			var container = document.querySelector(selectors.modalContainer);
			container.appendChild(el);
		}

		// Remove any modal not already in #ProductModals
		function removeDuplicateModals(modals) {
			if (modals.length > 1) {
				modals.forEach(function (m, i) {
					if (!m.closest('#ProductModals')) {
						m.remove();
					}
				})
			}
		}

		function enableTriggers(data) {
			// Setup quick view modal
			var modalId = 'QuickShopModal-' + data.id;
			var name = 'quick-modal-' + data.id;
			new theme.Modals(modalId, name);

			var triggers = document.querySelectorAll(selectors.triggers + '[data-handle="' + data.handle + '"]');

			if (!triggers.length) {
				return;
			}

			triggers.forEach(trigger => {
				trigger.classList.remove('quick-product__btn--not-ready');
			});
		}

		QuickShop.prototype = Object.assign({}, QuickShop.prototype, {
			init: function () {
				var products = this.container.querySelectorAll(selectors.product);

				if (!products.length) {
					return;
				}

				products.forEach(product => {
					product.addEventListener('mouseover', productMouseover);
				});
			}
		});

		return QuickShop;
	})();

	theme.Sections = function Sections() {
		this.constructors = {};
		this.instances = [];

		document.addEventListener('shopify:section:load', this._onSectionLoad.bind(this));
		document.addEventListener('shopify:section:unload', this._onSectionUnload.bind(this));
		document.addEventListener('shopify:section:select', this._onSelect.bind(this));
		document.addEventListener('shopify:section:deselect', this._onDeselect.bind(this));
		document.addEventListener('shopify:block:select', this._onBlockSelect.bind(this));
		document.addEventListener('shopify:block:deselect', this._onBlockDeselect.bind(this));
	};

	theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
		_createInstance: function (container, constructor, scope) {
			var id = container.getAttribute('data-section-id');
			var type = container.getAttribute('data-section-type');

			constructor = constructor || this.constructors[type];

			if (typeof constructor === 'undefined') {
				return;
			}

			// If custom scope passed, check to see if instance
			// is already initialized so we don't double up
			if (scope) {
				var instanceExists = this._findInstance(id);
				if (instanceExists) {
					this._removeInstance(id);
				}
			}

			// If a section fails to init, handle the error without letting all subsequest section registers to fail
			try {
				var instance = Object.assign(new constructor(container), {
					id: id,
					type: type,
					container: container
				});
				this.instances.push(instance);
			} catch (e) {
				console.error(e);
			}
		},

		_findInstance: function (id) {
			for (var i = 0; i < this.instances.length; i++) {
				if (this.instances[i].id === id) {
					return this.instances[i];
				}
			}
		},

		_removeInstance: function (id) {
			var i = this.instances.length;
			var instance;

			while (i--) {
				if (this.instances[i].id === id) {
					instance = this.instances[i];
					this.instances.splice(i, 1);
					break;
				}
			}

			return instance;
		},

		_onSectionLoad: function (evt, subSection, subSectionId) {
			// if (window.AOS) { AOS.refreshHard() }
			if (theme && theme.initGlobals) {
				theme.initGlobals();
			}

			var container = subSection ? subSection : evt.target;
			var section = subSection ? subSection : evt.target.querySelector('[data-section-id]');

			if (!section) {
				return;
			}

			this._createInstance(section);

			var instance = subSection ? subSectionId : this._findInstance(evt.detail.sectionId);

			// Check if we have subsections to load
			var haveSubSections = container.querySelectorAll('[data-subsection]');
			if (haveSubSections.length) {
				this.loadSubSections(container);
			}

			// Run JS only in case of the section being selected in the editor
			// before merchant clicks "Add"
			if (instance && typeof instance.onLoad === 'function') {
				instance.onLoad(evt);
			}

			// Force editor to trigger scroll event when loading a section
			setTimeout(function () {
				window.dispatchEvent(new Event('scroll'));
			}, 200);
		},

		_onSectionUnload: function (evt) {
			this.instances = this.instances.filter(function (instance) {
				var isEventInstance = instance.id === evt.detail.sectionId;

				if (isEventInstance) {
					if (typeof instance.onUnload === 'function') {
						instance.onUnload(evt);
					}
				}

				return !isEventInstance;
			});
		},

		loadSubSections: function (scope) {
			if (!scope) {
				return;
			}

			var sections = scope.querySelectorAll('[data-section-id]');

			sections.forEach(el => {
				this._onSectionLoad(null, el, el.dataset.sectionId);
			});
		},

		_onSelect: function (evt) {
			var instance = this._findInstance(evt.detail.sectionId);

			if (
				typeof instance !== 'undefined' &&
				typeof instance.onSelect === 'function'
			) {
				instance.onSelect(evt);
			}
		},

		_onDeselect: function (evt) {
			var instance = this._findInstance(evt.detail.sectionId);

			if (
				typeof instance !== 'undefined' &&
				typeof instance.onDeselect === 'function'
			) {
				instance.onDeselect(evt);
			}
		},

		_onBlockSelect: function (evt) {
			var instance = this._findInstance(evt.detail.sectionId);

			if (
				typeof instance !== 'undefined' &&
				typeof instance.onBlockSelect === 'function'
			) {
				instance.onBlockSelect(evt);
			}
		},

		_onBlockDeselect: function (evt) {
			var instance = this._findInstance(evt.detail.sectionId);

			if (
				typeof instance !== 'undefined' &&
				typeof instance.onBlockDeselect === 'function'
			) {
				instance.onBlockDeselect(evt);
			}
		},

		register: function (type, constructor, scope) {
			this.constructors[type] = constructor;

			var sections = document.querySelectorAll('[data-section-type="' + type + '"]');

			if (scope) {
				sections = scope.querySelectorAll('[data-section-type="' + type + '"]');
			}

			sections.forEach(
				function (container) {
					this._createInstance(container, constructor, scope);
				}.bind(this)
			);
		},

		reinit: function (section) {
			for (var i = 0; i < this.instances.length; i++) {
				var instance = this.instances[i];
				if (instance['type'] === section) {
					if (typeof instance.forceReload === 'function') {
						instance.forceReload();
					}
				}
			}
		}
	});

	theme.QtySelector = (function () {
		var selectors = {
			input: '.js-qty__num',
			plus: '.js-qty__adjust--plus',
			minus: '.js-qty__adjust--minus'
		};

		function QtySelector(el, options) {
			this.wrapper = el;
			this.plus = el.querySelector(selectors.plus);
			this.minus = el.querySelector(selectors.minus);
			this.input = el.querySelector(selectors.input);
			this.minValue = this.input.getAttribute('min') || 1;

			var defaults = {
				namespace: null,
				isCart: false,
				key: this.input.dataset.id
			};

			this.options = Object.assign({}, defaults, options);

			this.init();
		}

		QtySelector.prototype = Object.assign({}, QtySelector.prototype, {
			init: function () {
				this.plus.addEventListener('click', function () {
					var qty = this._getQty();
					this._change(qty + 1);
				}.bind(this));

				this.minus.addEventListener('click', function () {
					var qty = this._getQty();
					this._change(qty - 1);
				}.bind(this));

				this.input.addEventListener('change', function (evt) {
					this._change(this._getQty());
					console.log("quantity changed", this._getQty());
				}.bind(this));
			},

			_getQty: function () {
				var qty = this.input.value;
				if ((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
					// We have a valid number!
				} else {
					// Not a number. Default to 1.
					qty = 1;
				}
				return parseInt(qty);
			},

			_change: function (qty) {
				if (qty <= this.minValue) {
					qty = this.minValue;
				}

				this.input.value = qty;

				if (this.options.isCart) {
					document.dispatchEvent(new CustomEvent('cart:quantity' + this.options.namespace, {
						detail: [this.options.key, qty, this.wrapper]
					}));
				}
			}
		});

		return QtySelector;
	})();

	/**
	 * Currency Helpers
	 * -----------------------------------------------------------------------------
	 * A collection of useful functions that help with currency formatting
	 *
	 * Current contents
	 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
	 *   - When theme.settings.superScriptPrice is enabled, format cents in <sup> tag
	 * - getBaseUnit - Splits unit price apart to get value + unit
	 *
	 */

	theme.Currency = (function () {
		var moneyFormat = '${{amount}}';
		var superScript = theme && theme.settings && theme.settings.superScriptPrice;

		function formatMoney(cents, format) {
			if (!format) {
				format = theme.settings.moneyFormat;
			}

			if (typeof cents === 'string') {
				cents = cents.replace('.', '');
			}
			var value = '';
			var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
			var formatString = (format || moneyFormat);

			function formatWithDelimiters(number, precision, thousands, decimal) {
				precision = theme.utils.defaultTo(precision, 2);
				thousands = theme.utils.defaultTo(thousands, ',');
				decimal = theme.utils.defaultTo(decimal, '.');

				if (isNaN(number) || number == null) {
					return 0;
				}

				number = (number / 100.0).toFixed(precision);

				var parts = number.split('.');
				var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
				var centsAmount = parts[1] ? (decimal + parts[1]) : '';

				return dollarsAmount + centsAmount;
			}

			switch (formatString.match(placeholderRegex)[1]) {
				case 'amount':
					value = formatWithDelimiters(cents, 2);

					if (superScript && value && value.includes('.')) {
						value = value.replace('.', '<sup>') + '</sup>';
					}

					break;
				case 'amount_no_decimals':
					value = formatWithDelimiters(cents, 0);
					break;
				case 'amount_with_comma_separator':
					value = formatWithDelimiters(cents, 2, '.', ',');

					if (superScript && value && value.includes('.')) {
						value = value.replace(',', '<sup>') + '</sup>';
					}

					break;
				case 'amount_no_decimals_with_comma_separator':
					value = formatWithDelimiters(cents, 0, '.', ',');
					break;
				case 'amount_no_decimals_with_space_separator':
					value = formatWithDelimiters(cents, 0, ' ');
					break;
			}

			return formatString.replace(placeholderRegex, value);
		}

		function getBaseUnit(variant) {
			if (!variant) {
				return;
			}

			if (!variant.unit_price_measurement || !variant.unit_price_measurement.reference_value) {
				return;
			}

			return variant.unit_price_measurement.reference_value === 1
				? variant.unit_price_measurement.reference_unit
				: variant.unit_price_measurement.reference_value +
				variant.unit_price_measurement.reference_unit;
		}

		return {
			formatMoney: formatMoney,
			getBaseUnit: getBaseUnit
		}
	})();


	theme.Product = (function () {
		var slider = tns({
			container: '#product-image-slider',
			items: 1,
			slideBy: 'page',
			autoplay: false,
			"navAsThumbnails": true,
			navContainer: '#product-image-slider-nav',
			nextButton: '#product-image-slider-next',
			prevButton: '#product-image-slider-prev',
		});

		var params = new URLSearchParams(window.location.search);

		if (document.querySelector('#product-image-slider-nav.nav-slider')) {
			tns({
				container: '#product-image-slider-nav.nav-slider',
				items: 3,
				slideBy: 1,
				autoplay: false,
				arrowKeys: true,
				nextButton: '#product-image-slider-nav-next',
				prevButton: '#product-image-slider-nav-prev',
				nav: false,
				loop: false,
			})
		}

		var classes = {
			onSale: 'on-sale',
			disabled: 'disabled',
			isModal: 'is-modal',
			loading: 'loading',
			loaded: 'loaded',
			hidden: 'hide',
			interactable: 'video-interactable',
			visuallyHide: 'visually-invisible'
		};

		var selectors = {
			productVideo: '.product__video',
			videoParent: '.product__video-wrapper',
			slide: '.product-main-slide',
			currentSlide: '.is-selected',
			startingSlide: '.starting-slide',
			variantType: '.variant-wrapper',
			blocks: '[data-product-blocks]',
			blocksHolder: '[data-blocks-holder]',
			option1: '[data-option-index="1"]',
			option2: '[data-option-index="2"]',
			option3: '[data-option-index="3"]',
		};

		function updateProductImage(option1) {
			let productImage = document.querySelector('[data-product-photos] img[data-option-1="' + option1 + '"]');
			if (productImage) {
				slider.goTo(Number(productImage.dataset.index) - 1);
			}
		}

		var selectedOptions = [];

		let productForm = document.getElementById('ProductForm');

		// enable option fade
		let enableOptionFade = true;
		if ((productForm.querySelector(selectors.option1) !== null) && (productForm.querySelector(selectors.option2) !== null)) {
			enableOptionFade = productForm.querySelector(selectors.option1).dataset.optionName === 'color' && productForm.querySelector(selectors.option2).dataset.optionName === 'length'
		}

		let getVariantID = function () {
			let option1 = selectedOptions[0] ? `[data-option1-value="${selectedOptions[0]}"]` : '';
			let option2 = selectedOptions[1] ? `[data-option2-value="${selectedOptions[1]}"]` : '';
			let option3 = selectedOptions[2] ? `[data-option3-value="${selectedOptions[2]}"]` : '';
			let variantOption = productForm.querySelector(`#productSelect ${option1}${option2}${option3}`)

			let variantID = variantOption ? variantOption.value : null;

			return variantID;
		}

		window.getVariantID = getVariantID;

		productForm.querySelector('input#Quantity').addEventListener('focus', function (e) {
			this.value = '';
		});

		// quantity buttons
		productForm.querySelector('.js-qty-plus').addEventListener('click', function (e) {
			e.preventDefault()
			productForm.querySelector('input#Quantity').value = parseInt(productForm.querySelector('input#Quantity').value) + 1;
			resizeInput();
		});

		productForm.querySelector('.js-qty-minus').addEventListener('click', function (e) {
			e.preventDefault()
			if (parseInt(productForm.querySelector('input#Quantity').value) > 1) {
				productForm.querySelector('input#Quantity').value = parseInt(productForm.querySelector('input#Quantity').value) - 1;
			} else {
				productForm.querySelector('input#Quantity').value = 1;
			}
			resizeInput();
		});


		function resizeInput(el = productForm.querySelector('input#Quantity')) {
			el.style.width = ((el.value.length + 1) * 8) + 16 + 'px'; // 8 is an approximate width of a character, adjust as necessary
		}

		function updateSKU(productForm, newProductForm) {
			let newSKU = newProductForm.querySelector('[data-product-sku]').innerHTML;
			productForm.querySelector('[data-product-sku]').innerHTML = newSKU;
		}

		function updateButton(newProductForm) {
			// console.log("update button", variantID)
			let available = newProductForm.querySelector('[data-available]').dataset.available === 'true' ? true : false;
			let $atcButton = document.querySelector("[data-add-to-cart]:not(.bold_hidden)")
			// productForm.querySelector('#atc-text').innerHTML = newProductForm.querySelector('#atc-text').innerHTML;

			// console.log("available", available, variantID, document.querySelector(`#productSelect [value="${variantID}"]`))
			if (!available) {
				// document.querySelector('[data-product-sku]').innerHTML = 'Unavailable';

				$atcButton.classList.add('disabled');
				$atcButton.disabled = true;
			} else {
				$atcButton.classList.remove('disabled');
				$atcButton.disabled = false;
			}
		}

		function getOptionIDs() {
			productForm.querySelectorAll('[data-option-index]').forEach(function (optionEl, index) {
				console.log("optionEl", optionEl, index)

				const checkedRadio = optionEl.querySelector(`input[type="radio"][name="option-${index}"]:checked`);
				const selectDropdown = optionEl.querySelector(`select[name="option-${index}"]`);

				selectedOptions[index] = checkedRadio ? checkedRadio.dataset.optionId : (selectDropdown ? selectDropdown.dataset.optionId : null);
			});

			console.log("selected options", selectedOptions);
			return selectedOptions;
		}

		productForm.querySelector('input#Quantity').addEventListener('input', function (e) {
			resizeInput();
		});

		document.addEventListener('variant:change', function (e) {
			console.log("variant changed", e.detail);
			// update the url with the option params without reloading the page
			let url = new URL(window.location);
			let params = new URLSearchParams(url.search);

			let optionIDs = e.detail.options.join(',');
			let sectionId = productForm.dataset.sectionId;
			let productSection = productForm.closest('[data-section-type="product"]')

			params.set('option_values', optionIDs);
			history.replaceState({}, '', `${url.pathname}?${params.toString()}`);

			// Fetch the product section with the new option value selection, and replace the option value picker with the new availability state
			fetch(`${url.pathname}?section_id=${sectionId}&option_values=${optionIDs}`)
				.then(response => response.text())
				.then(text => {
					const parser = new DOMParser();
					const doc = parser.parseFromString(text, 'text/html');
					const newProductForm = doc.getElementById('ProductForm');

					// replace product swatches
					productForm.querySelector('.product-swatches').innerHTML = newProductForm.querySelector('.product-swatches').innerHTML;
					productForm.dataset.selectedVariantId = newProductForm.dataset.selectedVariantId;
					productForm.querySelector('input[name="id"]').value = newProductForm.querySelector('input[name="id"]').value;

					// Reinitialize custom dropdowns after HTML replacement
					window.initColorDropdown && window.initColorDropdown();
					initProductOptions();
					updateButton(newProductForm);

					getOptionIDs();
					updateSKU(productSection, doc);
					updateVariantPrice(doc);

					// hide error message
					const errorMessage = productForm.querySelector('[data-product-error-container]');
					if (errorMessage) {
						errorMessage.classList.add('hidden');
					}
				})
				.catch(error => {
					console.error('Error fetching updated product form:', error);
				});
		});

		getOptionIDs();

		function initProductOptions() {
			if (productForm.querySelector(selectors.option1)) {
				productForm.querySelector(selectors.option1).addEventListener('change', function (e) {
					getOptionIDs();

					updateProductImage(selectedOptions[0]);

					document.dispatchEvent(new CustomEvent('variant:change', {
						detail: {
							options: getOptionIDs(),
						}
					}));
				});
			}

			if (productForm.querySelector(selectors.option2)) {
				productForm.querySelector(selectors.option2).addEventListener('change', function (e) {
					getOptionIDs();

					updateProductImage(selectedOptions[0]);

					document.dispatchEvent(new CustomEvent('variant:change', {
						detail: {
							options: getOptionIDs(),
						}
					}));
				});
			}

			if (productForm.querySelector(selectors.option3)) {
				productForm.querySelector(selectors.option3).addEventListener('change', function (e) {
					selectedOptions[2] = e.target.dataset.optionId;

					updateProductImage(selectedOptions[0]);

					document.dispatchEvent(new CustomEvent('variant:change', {
						detail: {
							options: getOptionIDs(),
						}
					}));
				});
			}
		}

		initProductOptions();

		productForm.addEventListener('submit', function (e) {
			e.preventDefault();

			let $atcButton = document.querySelector("[data-add-to-cart]:not(.bold_hidden)")

			$atcButton.disabled = true;
			$atcButton.querySelector('#atc-loading').classList.remove('hidden');
			$atcButton.querySelector('#atc-text').classList.add('hidden');

			function added(res) {
				$atcButton.querySelector('#atc-loading').classList.add('hidden');
				$atcButton.querySelector('#atc-text').classList.remove('hidden');
				$atcButton.disabled = false;

				// Show cart dialog modal here
				show_cart_dialog_modal(res);

				// Init close cart dialog modal btns   
				init_close_cart_dialog_modal_btns();

				updateHeaderCart();

				document.dispatchEvent(new CustomEvent('cart:updated'));

				// redirect to cart page
				// productForm.querySelector('#AddToCart').classList.contains('zs-chain-prompt') ? window.location.href = '/cart?zs-chain-prompt' : window.location.href = '/cart';
			}

			// Cart popup focusTrap config
			let cart_popup_focus_trap = null;
			const cart_popup_container = document.querySelector('.cart-popup-dialog');
			const cart_popup_cart_btn = document.querySelector('.cart-popup-dialog #cart-dialog-view-cart');

			if (focusTrap && !var_is_empty(cart_popup_container) && !var_is_empty(cart_popup_cart_btn)) {
				cart_popup_focus_trap = focusTrap.createFocusTrap('.cart-popup-dialog', {
					fallbackFocus: cart_popup_container,
					initialFocus: cart_popup_cart_btn,
					escapeDeactivates: true,
					// clickOutsideDeactivates: true,
					onActivate: () => cart_popup_container.classList.add("focus-is-active"),
					onDeactivate: () => cart_popup_container.classList.remove("focus-is-active"),
				});
			}


			function show_cart_dialog_modal(res) {
				let cart_dialog_backdrop = document.querySelector('.cart-popup-dialog');

				if (var_is_empty(cart_dialog_backdrop)) {
					return;
				}

				// Get metadata options
				let product_option_values = res.options_with_values;
				product_option_values.push({ name: "QUANTITY", value: res.quantity });
				let product_sku_value = res.sku;

				let product_price = document.querySelector("span[data-product-price]").textContent;


				// Set metafields
				let cart_dialog_metafield_wrapper = cart_dialog_backdrop.querySelector('.cart-dialog-meta > .dynamic-fields');
				if (!var_is_empty(cart_dialog_metafield_wrapper) && !var_is_empty(product_option_values)) {
					product_option_values.forEach(function (option) {
						let option_name = option.name.toLowerCase();
						let option_value = option.value;

						let option_display_el = document.createElement('div', { class: "text-left text-base" });
						option_display_el.innerHTML = `<span class="capitalize">${option_name}:</span> ${option_value}`;

						cart_dialog_metafield_wrapper.appendChild(option_display_el);
					});
				}

				// Set sku
				let cart_sku_field = cart_dialog_backdrop.querySelector('.cart-dialog-meta > .sku-field');
				if (!var_is_empty(cart_sku_field)) {
					cart_sku_field.innerHTML = product_sku_value;
				}

				// Set price
				let cart_price_field = cart_dialog_backdrop.querySelector('#cart-product-price');
				if (!var_is_empty(cart_price_field)) {
					cart_price_field.innerHTML = product_price;
				}

				// Focus on primary btn
				let cart_dialog_primary_btn = cart_dialog_backdrop.querySelector('.cart-dialog-view-cart');
				if (!var_is_empty(cart_dialog_primary_btn)) {
					cart_dialog_primary_btn.focus();
				}

				// Reveal the cart dialog modal
				if (cart_dialog_backdrop.classList.contains('hidden')) {
					cart_dialog_backdrop.classList.remove('hidden');
				}
				if (cart_dialog_backdrop.classList.contains("opacity-0")) {
					cart_dialog_backdrop.classList.replace("opacity-0", "opacity-100");
				}

				// Focus trap activation
				if (cart_popup_focus_trap || cart_popup_focus_trap !== null) {
					cart_popup_focus_trap.activate();
				}


				function dismiss_dialog_on_esc() {
					document.addEventListener('keydown', function (e) {
						if (e.key === "Escape") {
							hide_dialog_cart_modal(cart_dialog_backdrop);
						}
					});
				}

				function dismiss_dialog_on_click_outside() {
					document.addEventListener('click', function (e) {
						let target_el = e.target;

						if (target_el.classList.contains('cart-popup-dialog')) {
							hide_dialog_cart_modal(cart_dialog_backdrop);
						}
					});
				}


				dismiss_dialog_on_esc();
				dismiss_dialog_on_click_outside();
			}


			function init_close_cart_dialog_modal_btns() {
				let cart_dialog_backdrop = document.querySelector('.cart-popup-dialog');
				let cart_dialog_close_btn = document.querySelector('#cart-dialog-close-btn');
				let cart_dialog_continue_btn = document.querySelector('#cart-dialog-continue-shopping');

				if (var_is_empty(cart_dialog_backdrop) || var_is_empty(cart_dialog_close_btn) || var_is_empty(cart_dialog_continue_btn)) {
					return;
				}

				[cart_dialog_close_btn, cart_dialog_continue_btn].forEach(function (btn) {
					btn.addEventListener('click', function () {
						hide_dialog_cart_modal(cart_dialog_backdrop);
					});
				});
			}


			function hide_dialog_cart_modal(el_backdrop) {
				let metafields_wrapper = el_backdrop.querySelector('.cart-dialog-meta > .dynamic-fields');

				if (!el_backdrop.classList.contains('hidden')) {
					el_backdrop.classList.add('hidden');
				}
				if (el_backdrop.classList.contains("opacity-100")) {
					el_backdrop.classList.replace("opacity-100", "opacity-0");
				}

				// Hide dynamic fields
				if (!var_is_empty(metafields_wrapper)) {
					metafields_wrapper.innerHTML = "";
				}

				// Focus trap deactivation
				if (cart_popup_focus_trap || cart_popup_focus_trap !== null) {
					cart_popup_focus_trap.deactivate();
				}
			}

			/* 
				Check if variable is empty
			*/
			function var_is_empty(ref) {
				if (typeof ref === "undefined" || ref === null) {
					return true;
				}

				return false;
			}

			// productForm.submit();

			let $productForm = $('#ProductForm')
			_ajax.addToCartForm($productForm, added, function (err) {
				console.log(err)

				console.log(err)

				const $atcButton = document.querySelector("[data-add-to-cart]:not(.bold_hidden)");
				const errorContainer = productForm.querySelector('[data-product-error-container]');

				// Re-enable the button and hide the loader
				$atcButton.disabled = false;
				$atcButton.querySelector('#atc-loading').classList.add('hidden');
				$atcButton.querySelector('#atc-text').classList.remove('hidden');

				// Show the error message from Shopify
				if (errorContainer && err.responseText) {
					const response = JSON.parse(err.responseText);
					errorContainer.textContent = response.description;
					errorContainer.classList.remove('hidden');
				}
			});

			document.dispatchEvent(new CustomEvent('product:adding'));
		});

		const addTooltip = function (el, text) {
			// if tooltip added return
			if (el.querySelector('.zs-tooltip')) return;

			let tooltip = document.createElement('div');
			tooltip.classList.add('zs-tooltip');
			// tooltip.innerHTML = text;
			tooltip.attributes.title = text;
			el.appendChild(tooltip);
		}

		const addToolTips = () => {
			document.querySelectorAll('.bold_option_title').forEach((el) => {
				addTooltip(el, '');
			});
		}


		// Show selected color
		function showSelectedColor() {
			document.querySelectorAll('.product-swatch-color').forEach(radio => {
				radio.addEventListener('change', function (e) {
					document.querySelector('#selected-color').innerHTML = `- "${e.target.value}"`;

					updateColorDropdown(e.target.value);
				})
			})
		};
		showSelectedColor();

		// color dropdown
		function initColorDropdown() {
			document.querySelectorAll('.zs-color-dropdown li').forEach(el => {
				el.addEventListener('click', function (e) {
					document.querySelector(`.product-swatch-color[value="${this.getAttribute('rel')}"]`).click()
				})
			})
		}

		function updateColorDropdown(value) {
			if (!document.querySelector(`.zs-color-dropdown select option[value="${value}"]`)) return;
			document.querySelector(`.zs-color-dropdown select option[value="${value}"]`).selected = true;
			document.querySelector(`.zs-color-dropdown li[rel="${value}"]`).click()
		}

		initColorDropdown();

		// updateVariant Price
		function updateVariantPrice(newProductForm) {
			// Find the price elements within the new HTML fragment from the server
			const newPriceEl = newProductForm.querySelector('[data-product-price]');
			const newCompareAtPriceEl = newProductForm.querySelector('[data-product-compare-at-price]');
			const newSavingsEl = newProductForm.querySelector('[data-product-savings]');

			// Find the price elements in the live DOM
			const currentPriceEls = document.querySelectorAll('[data-product-price]');
			const currentCompareAtPriceEl = document.querySelector('[data-product-compare-at-price]');
			const currentSavingsEl = document.querySelector('[data-product-savings]');

			console.log("updating price", newPriceEl, newCompareAtPriceEl, newSavingsEl);

			// Update the main price display
			if (newPriceEl && currentPriceEls.length) {
				currentPriceEls.forEach(el => {
					el.innerHTML = newPriceEl.innerHTML;
				});
			}

			// Update the compare-at price display
			if (currentCompareAtPriceEl) {
				if (newCompareAtPriceEl && newCompareAtPriceEl.innerHTML.trim() !== '') {
					currentCompareAtPriceEl.innerHTML = newCompareAtPriceEl.innerHTML;
					currentCompareAtPriceEl.classList.remove('hidden');
				} else {
					currentCompareAtPriceEl.innerHTML = '';
					currentCompareAtPriceEl.classList.add('hidden');
				}
			}

			// Update the savings display
			if (currentSavingsEl) {
				if (newSavingsEl && newSavingsEl.innerHTML.trim() !== '') {
					currentSavingsEl.innerHTML = newSavingsEl.innerHTML;
					currentSavingsEl.classList.remove('hidden');
				} else {
					currentSavingsEl.innerHTML = '';
					currentSavingsEl.classList.add('hidden');
				}
			}
		}

		function updateHeaderCart() {
			let $cartIcon = document.querySelector('[data-header-cart]');
			let $cartIconLoader = document.querySelector('[data-header-cart-loader]');

			$cartIcon.classList.add('hidden');
			$cartIconLoader.classList.remove('hidden');

			theme.cart.getCart().then((res) => {
				res?.item_count && ($cartIcon.querySelector('[data-cart-count]').innerHTML = res.item_count);
				res?.total_price && ($cartIcon.querySelector('[data-cart-total]').innerHTML = theme.Currency.formatMoney(res.total_price, theme.settings.moneyFormat));

				$cartIcon.classList.remove('hidden');
				$cartIconLoader.classList.add('hidden');
				// console.log("got here cart", res)
			})
		}

		let extractNumber = (text) => {
			const match = text.match(/(\d+(\.\d+)?)/);
			return match ? (match[0] - 0.25) : null;
		}

		// init customization input constraints - prevent using a number greater than the selected length
		function initCustomizationInput() {
			let lengthSwatchRadio = document.querySelectorAll('#ProductForm .product-swatch-length');
			window.customLengthMaxValue = extractNumber(document.querySelector('.product-swatch-length:checked')?.value);

			if (lengthSwatchRadio.length > 0) {
				lengthSwatchRadio.forEach(radio => {
					radio.addEventListener('change', function (e) {
						let customLengthInput = document.querySelector('[data-custom-length-initialized] input[type="number"]')
						let val = extractNumber(e.target.value)

						window.customLengthMaxValue = val
						if (customLengthInput) {
							customLengthInput.setAttribute('max', val)
						}
					})
				})
			}
		}
		initCustomizationInput();
	});

	theme.LoginPage = (function () {
		// forgot password
		document.querySelector('#forgot-password').addEventListener('click', function (e) {
			e.preventDefault();
			document.querySelector('#login-form').classList.add('hidden');
			document.querySelector('#forgot-password-form').classList.remove('hidden');
		});

		document.querySelector("#hide-recover").addEventListener('click', function (e) {
			e.preventDefault();
			document.querySelector('#login-form').classList.remove('hidden');
			document.querySelector('#forgot-password-form').classList.add('hidden');
		});
	})

	theme.HeaderMenu = (function () {
		let headerOpen = false;
		let screenHeight = window.innerHeight;
		let headerHeight = document.querySelector('.header-section').offsetHeight;

		document.querySelector('#mobile-menu-toggle').addEventListener('click', function (e) {
			e.preventDefault();

			document.querySelector('#mobile-menu').style.minHeight = `${screenHeight - headerHeight}px`;
			document.querySelector('#mobile-menu').style.height = 'auto'

			if (!headerOpen) {
				// document.querySelector('#mobile-menu').style.top = `${headerHeight}px`;
				document.querySelector('#mobile-menu').style.transform = `translateY(${headerHeight}px)`;
				headerOpen = true;
			} else {
				// document.querySelector('#mobile-menu').style.top = `-${screenHeight + headerHeight}px`;
				document.querySelector('#mobile-menu').style.transform = `translateY(-100%)`;
				headerOpen = false;
			}
		})

		document.querySelectorAll('.mega-menu__has-sublinks').forEach(function (el) {
			el.addEventListener('click', function (e) {
				e.preventDefault();

				if (el.classList.contains('active')) {
					el.classList.remove('active');
					el.nextElementSibling.style.height = `${el.nextElementSibling.scrollHeight}px`;

					setTimeout(function () {
						el.nextElementSibling.style.height = `0px`;
					}, 100);

					el.querySelector('svg').style.transform = "rotate(0deg)";

					return;
				} else {
					el.classList.add('active');
					el.nextElementSibling.style.height = `${el.nextElementSibling.scrollHeight}px`;
					el.querySelector('svg').style.transform = "rotate(90deg)";

					setTimeout(function () {
						el.nextElementSibling.style.height = `auto`;
					}, 500);
				}
			});
		});
	});

	theme.cart = {
		getCart: function () {
			var url = ''.concat(theme.routes.cart, '?t=').concat(Date.now());
			return fetch(url, {
				credentials: 'same-origin',
				method: 'GET'
			}).then(response => response.json());
		},

		getCartProductMarkup: function () {
			var url = ''.concat(theme.routes.cartPage, '?t=').concat(Date.now());

			url = url.indexOf('?') === -1 ? (url + '?view=ajax') : (url + '&view=ajax');

			return fetch(url, {
				credentials: 'same-origin',
				method: 'GET'
			})
				.then(function (response) {
					return response.text()
				});
		},

		changeItem: function (key, qty) {
			return this._updateCart({
				url: ''.concat(theme.routes.cartChange, '?t=').concat(Date.now()),
				data: JSON.stringify({
					id: key,
					quantity: qty
				})
			})
			setTimeout(function () { window.getCartInfo(); }, 200);
		},

		_updateCart: function (params) {
			return fetch(params.url, {
				method: 'POST',
				body: params.data,
				credentials: 'same-origin',
				headers: {
					'Content-Type': 'application/json',
					'X-Requested-With': 'XMLHttpRequest'
				}
			})
				.then(response => response.json())
				.then(function (cart) {
					return cart;
				});
			setTimeout(function () { window.getCartInfo(); }, 200);
		},

		updateAttribute: function (key, value) {
			return this._updateCart({
				url: '/cart/update.js',
				data: JSON.stringify({
					attributes: {
						[key]: theme.cart.attributeToString(value)
					}
				})
			});
		},

		updateNote: function (note) {
			return this._updateCart({
				url: '/cart/update.js',
				data: JSON.stringify({
					note: theme.cart.attributeToString(note)
				})
			});
		},

		attributeToString: function (attribute) {
			if ((typeof attribute) !== 'string') {
				attribute += '';
				if (attribute === 'undefined') {
					attribute = '';
				}
			}
			return attribute.trim();
		}
	}

	theme.CartPage = (function () {
		let cartForm = document.getElementById('CartForm');
		let shippingEstimateForm = document.querySelector('[data-shipping-form]');

		// display slider popup
		let url = new URL(window.location.href);
		// if (url.searchParams.has('zs-chain-prompt')) {
		// 	document.querySelector('#order-sliders-popup').classList.remove('hidden');

		// 	document.querySelector('#order-sliders-popup button#close').addEventListener('click', function (e) {
		// 		e.preventDefault();
		// 		document.querySelector('#order-sliders-popup').classList.add('hidden');
		// 	});

		// 	url.searchParams.delete('zs-chain-prompt');

		// 	window.history.replaceState({}, '', url);
		// }


		// estimate shipping
		AddressForm(document.querySelector('[data-address=root]'), 'en', {
			shippingCountriesOnly: true,
		});

		document.querySelector('[data-estimate-shipping]').addEventListener('click', function (e) {
			e.preventDefault();
			document.querySelector('[data-shipping-form-overlay]').classList.remove('hidden');
		});

		document.querySelector('[data-shipping-form]').addEventListener('submit', function (e) {
			e.preventDefault();
			let _el = this;

			let formData = new FormData(this);
			_el.querySelector('.zs-loading').classList.remove('hidden');
			_el.querySelector('.zs-btn-main').classList.add('hidden');
			_el.querySelector('button[type="submit"]').disabled = true;

			_ajax.getShippingRates(
				{
					province: formData.get('address[province]'),
					country: formData.get('address[country]'),
					zip: formData.get('address[zip]'),
				},
				({ shipping_rates: rates }) => {
					console.log("rates", rates);
					_el.querySelector('.zs-loading').classList.add('hidden');
					_el.querySelector('.zs-btn-main').classList.remove('hidden');
					_el.querySelector('button[type="submit"]').disabled = false;

					if (rates && rates.length > 0) {
						// document.querySelector('#shipping-rates').appendChild(document.querySelector('#shipping-rate-template').content.cloneNode(true));

						rates.forEach((rate) => {
							let newRate = document.querySelector('#shipping-rate-template').cloneNode(true);
							newRate.querySelector('.shipping-rate__name').innerHTML = rate.name;
							newRate.querySelector('.shipping-rate__price').innerHTML = `$${rate.price}`;
							document.querySelector('#shipping-rates').appendChild(newRate);
							document.querySelector('#shipping-rates').classList.remove('hidden');
						}
						);

						document.querySelector('[data-shipping-form]').classList.add('hidden');
					} else {
						document.querySelector('#shipping-rates').appendChild(document.querySelector('#shipping-rate-template').content.cloneNode(true));
						// document.querySelector('#shipping-rates').appendChild(document.querySelector('#no-shipping-rates-template').content.cloneNode(true));
					}
				},
				(error) => {
					console.log("error", error, error.data);
					shippingEstimateForm.querySelector('#errors-zip').innerHTML = error.data.zip.map((err) => `<li>${err}</li>`).join('');

					_el.querySelector('.zs-loading').classList.add('hidden');
					_el.querySelector('.zs-btn-main').classList.remove('hidden');
					_el.querySelector('button[type="submit"]').disabled = false;
				}
			)
		})

		// close btns
		document.querySelectorAll('.close-btn').forEach(function (el) {
			el.addEventListener('click', function (e) {
				e.preventDefault();
				el.closest('[data-shipping-form-overlay]').classList.add('hidden');
			});
		}
		);

		window.addEventListener('BOLD_COMMON_cart_loaded', function (e) {
			console.log("cart loaded")
		})

		document.addEventListener('BOLD_COMMON_refresh', function (e) {
			console.log("refreshed")
		});

		document.addEventListener('cart:updated', function (e) {
			console.log("cart updated")
		});

		document.addEventListener('cart:quantity', function (e) {
			console.log("cart qty updated")
		});

	});


	const debounce = (fn, delay) => {
		let timeoutId;
		return function (...args) {
			clearTimeout(timeoutId);
			timeoutId = setTimeout(() => fn.apply(this, args), delay);
		};
	};

	/*============================================================================
	CartForm
	- Prevent checkout when terms checkbox exists
	- Listen to quantity changes, rebuild cart (both widget and page)
	==============================================================================*/
	theme.CartForm = (function () {
		var selectors = {
			products: '[data-products]',
			qtySelector: '.js-qty__wrapper',
			discounts: '[data-discounts]',
			savings: '[data-savings]',
			subTotal: '[data-subtotal]',

			cartBubble: '.cart-link__bubble',
			cartNote: '[name="note"]',
			termsCheckbox: '.cart__terms-checkbox',
			checkoutBtn: '.cart__checkout'
		};

		var classes = {
			btnLoading: 'btn--loading'
		};

		var config = {
			requiresTerms: false
		};

		function CartForm(form) {
			if (!form) {
				return;
			}

			this.form = form;
			this.wrapper = form.parentNode;
			this.location = form.dataset.location;
			this.namespace = '.cart-' + this.location;
			this.products = form.querySelector(selectors.products)
			this.submitBtn = form.querySelector(selectors.checkoutBtn);

			this.discounts = form.querySelector(selectors.discounts);
			this.savings = form.querySelector(selectors.savings);
			this.subtotal = form.querySelector(selectors.subTotal);
			this.termsCheckbox = form.querySelector(selectors.termsCheckbox);
			this.noteInput = form.querySelector(selectors.cartNote);

			if (this.termsCheckbox) {
				config.requiresTerms = true;
			}

			this.init();
		}

		CartForm.prototype = Object.assign({}, CartForm.prototype, {
			init: function () {
				this.initQtySelectors();
				this.initFreeShippingText(Number(this.subtotal));
				this.initFreeShippingObserver();

				const intervalCart = setInterval(() => {
					if (typeof window.hulkapps.discounts !== 'undefined') {
						theme.cart.getCartProductMarkup()
							.then((markup) => this.cartMarkup(markup));
						clearInterval(intervalCart);
					}
				}, 100);

				document.addEventListener('cart:quantity' + this.namespace, this.quantityChanged.bind(this));

				this.form.on('submit' + this.namespace, this.onSubmit.bind(this));

				if (this.noteInput) {
					this.noteInput.addEventListener('change', function () {
						var newNote = this.value;
						theme.cart.updateNote(newNote);
					});
				}

				// window.BOLD.common.eventEmitter.on(
				// 	'BOLD_OPTIONS_cart_prices_updated',
				// 	debounce(() => {
				// 		console.log('BOLD_OPTIONS_cart_prices_updated');

				// 		theme.cart.getCartProductMarkup()
				// 			.then((markup) => this.cartMarkup(markup));
				// 	}, 250)
				// );

				document.querySelectorAll('[data-cart-remove]').forEach(button => {
					button.addEventListener('click', (e) => {
						e.preventDefault();

						theme.cart.getCartProductMarkup()
							.then(markup => this.cartMarkup(markup))
							.catch(err => {
								console.error('Error updating cart markup:', err);
							});
					});
				});


				// Dev-friendly way to build the cart
				document.addEventListener('cart:build', function () {
					this.buildCart();
				}.bind(this));
			},

			reInit: function () {
				this.initQtySelectors();
			},

			initFreeShippingObserver: function () {
				let target = document.querySelector('[data-hulkapps-cart-total]');

				if (!target) return;
				let observer = new MutationObserver((mutations) => {
					mutations.forEach((mutation) => {
						this.initFreeShippingText(Number(this.subtotal));
					});
				});
				observer.observe(target, {
					childList: true,
					characterData: true,
					subtree: true
				});
			},

			onSubmit: function (evt) {
				evt.preventDefault();
				// this.submitBtn.classList.add(classes.btnLoading);

				if (config.requiresTerms) {
					if (this.termsCheckbox.checked) {
						// continue to checkout
					} else {
						alert(theme.strings.cartTermsConfirmation);
						this.submitBtn.classList.remove(classes.btnLoading)
						evt.preventDefault();
						return false;
					}
				}
			},

			/*============================================================================
				Query cart page to get markup
			==============================================================================*/
			_parseProductHTML: function (html) {
				var parser = new DOMParser();
				var doc = parser.parseFromString(html, 'text/html');
				return {
					items: doc.querySelector('.cart__items'),
					discounts: doc.querySelector('.cart__discounts')
				}
			},

			buildCart: function () {
				// bold causing an error with ajax cart
				// if(window.BOLD && BOLD.common && BOLD.common.cartDoctor && typeof BOLD.common.cartDoctor.fix === 'function'){
				// cart = BOLD.common.cartDoctor.fix(cart);
				// }

				theme.cart.getCartProductMarkup().then(this.cartMarkup.bind(this));

				// if (window.BOLD && BOLD.common && BOLD.common.eventEmitter && typeof BOLD.common.eventEmitter.emit === 'function') {
				// 	BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded');
				// }

				// setTimeout(() => {
				// 	theme.cart.getCartProductMarkup()
				// 		.then(this.cartMarkup.bind(this));
				// }, 500);
			},

			getHulkDiscountedTotal2: function (markup) {
				var items = markup.items;
				var boldCartCount = items.dataset.boldCartCount;
				var subtotal = items.dataset.cartSubtotal;

				if (window.BOLD && window.hulkapps) {
					let cartTotal = subtotal;
					let hulkDiscount = window.hulkapps.discounts.cart.items.map(item => {
						if (item.discounted_price < item.original_price) {
							return (item.original_price - item.discounted_price) * item.quantity;
						} else {
							return 0;
						}
					}).reduce((a, b) => a + b, 0)

					let discountedTotal = (cartTotal - hulkDiscount).toFixed(2);
					return discountedTotal;
				}
			},

			getHulkDiscountedTotal: function () {
				// console.log("hulk discounted total 1", window.hulkapps);
				if (window.hulkapps) {
					return Number(window.hulkapps.discounts?.discounted_line_price_total) || 0;
				}
			},

			getHulkDiscountedLinePrice: function (key, form) {
				if (window.BOLD && window.hulkapps) {
					let cartItems = window.hulkapps.discounts.cart.items;
					let item = cartItems.find(item => item.key === key);

					let lineDiscountedPrice = item.discounted_price * item.quantity;
					let boldCustomizationPrice = form.querySelector(`[data-key="${key}"]`).querySelector('[data-customization-price]').dataset.customizationPrice

					return (lineDiscountedPrice + parseFloat(boldCustomizationPrice)).toFixed(2);
				}
			},

			cartMarkup: function (html) {
				var markup = this._parseProductHTML(html);
				var items = markup.items;
				var count = parseInt(items.dataset.count);
				var subtotal = items.dataset.cartSubtotal;
				var savings = items.dataset.cartSavings;

				let hulkDiscountedTotal = this.getHulkDiscountedTotal(markup)

				if (hulkDiscountedTotal > 0) {
					savings = hulkDiscountedTotal;
				}

				if (count > 0) {
					this.wrapper.classList.remove('is-empty');
				} else {
					this.wrapper.classList.add('is-empty');
				}

				this.updateCount(count);

				// Append item markup
				this.products.innerHTML = '';
				this.products.append(items);

				// Update subtotal
				this.form.querySelectorAll(selectors.subTotal).forEach(element => {
					element.innerHTML = theme.Currency.formatMoney(subtotal, theme.settings.moneyFormat);
				});

				// update cart count
				// let boldCartCount = this.form.querySelector('.cart__items').dataset.boldCartCount
				// this.form.querySelector('[data-cart-count]').innerHTML = `${boldCartCount} ${boldCartCount > 1 ? 'items' : 'item'}`;

				// update line total
				this.form.querySelectorAll('[data-line-item]').forEach(el => {
					let key = el.dataset.key;
					let prevTotal = Number(el.querySelector('[data-final-line-price]').dataset.finalLinePrice) + Number(el.querySelector('[data-customization-price]').dataset.customizationPrice);
					let linePrice = this.getHulkDiscountedLinePrice(key, this.form);

					if (linePrice < prevTotal) {
						el.querySelector('[data-final-line-price]').classList.add('line-through', 'scale-90');
						el.querySelector('[data-line-savings]').classList.remove('hidden');
						el.querySelector('[data-line-savings]').innerHTML = theme.Currency.formatMoney(linePrice, theme.settings.moneyFormat);
					} else {
						el.querySelector('[data-final-line-price]').classList.remove('line-through', 'scale-90');
						el.querySelector('[data-line-savings]').classList.add('hidden');
					}
				});

				this.updateCartDiscounts(markup.discounts);
				this.updateSavings(savings, subtotal);

				this.reInit();

				if (window.AOS) { AOS.refreshHard() }

				if (Shopify && Shopify.StorefrontExpressButtons) {
					Shopify.StorefrontExpressButtons.initialize();
				}
			},

			updateCartDiscounts: function (markup) {
				if (!this.discounts) {
					return;
				}
				this.discounts.innerHTML = '';
				this.discounts.append(markup);
			},

			/*============================================================================
				Quantity handling
			==============================================================================*/
			initQtySelectors: function () {
				this.form.querySelectorAll(selectors.qtySelector).forEach(el => {
					var selector = new theme.QtySelector(el, {
						namespace: this.namespace,
						isCart: true
					});
				});
			},

			initFreeShippingText: function (subtotal) {
				// console.log("initFreeShippingText", subtotal);
				let hulkDiscountedTotal = this.getHulkDiscountedTotal()
				// update free shipping banner
				this.form.querySelectorAll('[data-free-ship-left]').forEach(el => {
					// console.log("buildng cart", window.hulkapps.discounts, hulkDiscountedTotal);
					// total is smallest of subtotal and hulk discounted total if hulkdiscounted total exists and is more than 0
					let total = hulkDiscountedTotal > 0 ? hulkDiscountedTotal : subtotal;
					let left = 100.00 - total;

					if (left <= 0) {
						el.closest('[data-free-ship-banner]').classList.add('hidden');
						return;
					}

					el.closest('[data-free-ship-banner]').classList.remove('hidden');
					el.innerHTML = theme.Currency.formatMoney((left * 100), theme.settings.moneyFormat);
				});
			},

			quantityChanged: function (evt) {
				var key = evt.detail[0];
				var qty = evt.detail[1];
				var el = evt.detail[2];

				if (!key || !qty) {
					return;
				}

				// if 0 remove from cart
				if (qty == 0) {
					window.location.href = `/cart/change?id=${key.split(":")[0]}&quantity=${qty}`;
				}


				// Disable qty selector so multiple clicks can't happen while loading
				document.querySelector(`[data-key="${key}"]`).style.opacity = '0.5';
				document.querySelector(`[data-key="${key}"]`).style.pointerEvents = 'none';
				if (el) {
					el.classList.add('is-loading');
				}

				theme.cart.changeItem(key, qty)
					.then(function (cart) {
						if (cart.item_count > 0) {
							this.wrapper.classList.remove('is-empty');
						} else {
							this.wrapper.classList.add('is-empty');
						}

						this.buildCart();

						document.dispatchEvent(new CustomEvent('cart:updated', {
							detail: {
								cart: cart
							}
						}));
					}.bind(this))
					.catch(function (XMLHttpRequest) { });
			},

			/*============================================================================
				Update elements of the cart
			==============================================================================*/
			updateSubtotal: function (subtotal) {
				this.form.querySelector(selectors.subTotal).innerHTML = theme.Currency.formatMoney(subtotal, theme.settings.moneyFormat);
			},

			updateSavings: function (savings, subtotal) {
				if (!this.savings) {
					return;
				}

				if (Number(savings) < Number(subtotal)) {
					var amount = theme.Currency.formatMoney(savings, theme.settings.moneyFormat);
					// this.form.querySelector('[data-savings').classList.remove('hidden');
					// this.savings.innerHTML = theme.strings.cartSavings.replace('[savings]', amount);
					this.form.querySelectorAll('[data-savings]').forEach(element => {
						element.classList.remove('hidden');
						element.innerHTML = amount;
					});

					this.form.querySelectorAll('[data-subtotal]').forEach(element => {
						element.classList.add('line-through', 'scale-90');
					});
				} else {
					this.form.querySelectorAll('[data-savings]').forEach(element => {
						element.classList.add('hidden')
					});

					this.form.querySelectorAll('[data-subtotal]').forEach(element => {
						element.classList.remove('line-through', 'scale-90');
					});
				}
			},

			updateCount: function (count) {
				var countEls = document.querySelectorAll('.cart-link__bubble-num');

				if (countEls.length) {
					countEls.forEach(el => {
						el.innerText = count;
					});
				}

				// show/hide bubble(s)
				var bubbles = document.querySelectorAll(selectors.cartBubble);
				if (bubbles.length) {
					if (count > 0) {
						bubbles.forEach(b => {
							b.classList.add('cart-link__bubble--visible');
						});
					} else {
						bubbles.forEach(b => {
							b.classList.remove('cart-link__bubble--visible');
						});
					}
				}
			}
		});

		return CartForm;
	})();

	theme.CollectionSidebar = (function () {
		var selectors = {
			sidebar: '#collection-sidebar',
		}

		document.querySelector('#mobile-filters-open').addEventListener('click', function (e) {
			e.preventDefault();
			document.querySelector("#mobile-filters-sidebar").style.left = "0";
		});

		document.querySelector('#mobile-filters-close').addEventListener('click', function (e) {
			e.preventDefault();
			document.querySelector("#mobile-filters-sidebar").style.left = "-100vw";
		})

		document.querySelectorAll('.collapsible-trigger-btn').forEach(function (el) {
			// el.querySelector('collapsible-trigger__icon').style.transform = "rotate(0deg)";

			el.addEventListener('click', function (e) {
				e.preventDefault();
				let collapsible = el.closest('.collection-sidebar__group').querySelector('.collapsible-content');

				if (collapsible.classList.contains('is-open')) {
					collapsible.classList.remove('is-open');
					collapsible.style.height = "0px";
				} else if (!collapsible.classList.contains('is-open')) {
					collapsible.classList.add('is-open');
					collapsible.style.height = `${collapsible.scrollHeight}px`;
				}

			});
		});

	});

	theme.addressForm = (function () {
		document.querySelector('#add-address').addEventListener('click', function (e) {
			e.preventDefault();
			document.querySelector('#new-address-form').classList.remove('hidden');
		})

		document.querySelector('#close-address-form').addEventListener('click', function (e) {
			e.preventDefault();
			document.querySelector('#new-address-form').classList.add('hidden');
		})

		AddressForm(document.querySelector('[data-address=root]'), 'en', {
			shippingCountriesOnly: true,
		});
	});

	// Init section function when it's visible, then disable observer
	theme.initWhenVisible = function (options) {
		var threshold = options.threshold ? options.threshold : 0;

		var observer = new IntersectionObserver((entries, observer) => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					if (typeof options.callback === 'function') {
						options.callback();
						observer.unobserve(entry.target);
					}
				}
			});
		}, { rootMargin: '0px 0px ' + threshold + 'px 0px' });

		observer.observe(options.element);
	};

	theme.LibraryLoader = (function () {
		var types = {
			link: 'link',
			script: 'script'
		};

		var status = {
			requested: 'requested',
			loaded: 'loaded'
		};

		var cloudCdn = 'https://cdn.shopify.com/shopifycloud/';

		var libraries = {
			youtubeSdk: {
				tagId: 'youtube-sdk',
				src: 'https://www.youtube.com/iframe_api',
				type: types.script
			},
			vimeo: {
				tagId: 'vimeo-api',
				src: 'https://player.vimeo.com/api/player.js',
				type: types.script
			},
			shopifyXr: {
				tagId: 'shopify-model-viewer-xr',
				src: cloudCdn + 'shopify-xr-js/assets/v1.0/shopify-xr.en.js',
				type: types.script
			},
			modelViewerUi: {
				tagId: 'shopify-model-viewer-ui',
				src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.en.js',
				type: types.script
			},
			modelViewerUiStyles: {
				tagId: 'shopify-model-viewer-ui-styles',
				src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.css',
				type: types.link
			}
		};

		function load(libraryName, callback) {
			var library = libraries[libraryName];

			if (!library) return;
			if (library.status === status.requested) return;

			callback = callback || function () { };
			if (library.status === status.loaded) {
				callback();
				return;
			}

			library.status = status.requested;

			var tag;

			switch (library.type) {
				case types.script:
					tag = createScriptTag(library, callback);
					break;
				case types.link:
					tag = createLinkTag(library, callback);
					break;
			}

			tag.id = library.tagId;
			library.element = tag;

			var firstScriptTag = document.getElementsByTagName(library.type)[0];
			firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
		}

		function createScriptTag(library, callback) {
			var tag = document.createElement('script');
			tag.src = library.src;
			tag.addEventListener('load', function () {
				library.status = status.loaded;
				callback();
			});
			return tag;
		}

		function createLinkTag(library, callback) {
			var tag = document.createElement('link');
			tag.href = library.src;
			tag.rel = 'stylesheet';
			tag.type = 'text/css';
			tag.addEventListener('load', function () {
				library.status = status.loaded;
				callback();
			});
			return tag;
		}

		return {
			load: load
		};
	})();

	theme.searchPage = (function () {
		let initProductsPerPage = function (_productsPerPage) {
			let url = new URL(window.location.href);

			let productsPerPage = url.searchParams.get('view') ?? _productsPerPage;

			if (productsPerPage) {
				document.querySelector('[data-products-per-page].active').classList.remove('active')

				document.querySelector(`[data-products-per-page="${productsPerPage}"]`).classList.add('active')
			}

			document.querySelectorAll('[data-products-per-page]').forEach(function (el) {
				el.addEventListener('click', function (e) {
					e.preventDefault();

					url.searchParams.set('view', el.dataset.productsPerPage);

					//load set url
					window.location.href = url;
				});
			});
		}

		initProductsPerPage(12);
	});


	/*============================================================================
		Things that require DOM to be ready
	==============================================================================*/
	function DOMready(callback) {
		if (document.readyState != 'loading') callback();
		else document.addEventListener('DOMContentLoaded', callback);
	}

	DOMready(function () {
		theme.sections = new theme.Sections();

		// theme.sections.register('slideshow-section', theme.SlideshowSection);
		// theme.sections.register('header', theme.HeaderSection);
		// theme.sections.register('toolbar', theme.Toolbar);
		theme.sections.register('product', theme.Product);
		theme.sections.register('login', theme.LoginPage);
		theme.sections.register('header', theme.HeaderMenu);
		theme.sections.register('cart-section', theme.CartPage);
		theme.sections.register('addresses', theme.addressForm);
		theme.sections.register('search', theme.searchPage);

		// theme.sections.register('password-header', theme.PasswordHeader);
		// theme.sections.register('photoswipe', theme.Photoswipe);
		// theme.sections.register('background-image', theme.BackgroundImage);
		// theme.sections.register('testimonials', theme.Testimonials);
		// theme.sections.register('video-section', theme.VideoSection);
		// theme.sections.register('map', theme.Maps);
		// theme.sections.register('footer-section', theme.FooterSection);
		// theme.sections.register('store-availability', theme.StoreAvailability);
		// theme.sections.register('recently-viewed', theme.RecentlyViewed);
		// theme.sections.register('vendor-products', theme.VendorProducts);
		// theme.sections.register('newsletter-popup', theme.NewsletterPopup);
		// theme.sections.register('collection-header', theme.CollectionHeader);
		theme.sections.register('collection-template', theme.Collection);
		theme.sections.register('collection-template', theme.CollectionSidebar);

		// theme.initGlobals();
		// theme.rteInit();

		// if (theme.settings.isCustomerTemplate) {
		//   theme.customerTemplates();
		// }

		if (document.body.classList.contains('template-cart')) {
			var cartPageForm = document.getElementById('cartForm');
			if (cartPageForm) {
				var cartForm = new theme.CartForm(cartPageForm);

				// var recommendations = document.querySelector('.cart-recommendations[data-location="page"]');
				// if (recommendations) {
				//   new theme.QuickAdd(recommendations);
				//   new theme.QuickShop(recommendations);
				// }

				// var noteBtn = cartPageForm.querySelector('.add-note');
				// if (noteBtn) {
				//   noteBtn.addEventListener('click', function() {
				//     noteBtn.classList.toggle('is-active');
				//     cartPageForm.querySelector('.cart__note').classList.toggle('hide');
				//   });
				// }

				document.addEventListener('ajaxProduct:added', function (evt) {
					cartForm.buildCart();
				}.bind(this));
			}
		}

		// // Enable quick view/quick shop on search page
		// if (document.body.classList.contains('template-search')) {
		//   var searchGrid = document.querySelector('.search-grid');
		//   if (searchGrid) {
		//     var searchProducts = searchGrid.querySelectorAll('.grid-product');
		//     if (searchProducts.length) {
		//       new theme.QuickAdd(searchGrid);
		//       new theme.QuickShop(searchGrid);
		//     }
		//   }
		// }

		// document.addEventListener('recommendations:loaded', function(evt) {
		//   if (evt && evt.detail && evt.detail.section) {
		//     new theme.QuickAdd(evt.detail.section);
		//     new theme.QuickShop(evt.detail.section);
		//   }
		// });

		// theme.pageTransitions();

		// initRecoverFormToggle();
		document.dispatchEvent(new CustomEvent('page:loaded'));
	});

	const addToCartError = function (error) {
		console.log(error);
	}

	const addToCartSuccess = function (data) {
		console.log(data);
	}

	const _ajax = {
		addToCart: function (productId, quantity, successCallback, errorCallback) {
			const data = {
				quantity: quantity,
				id: productId
			};

			fetch('/cart/add.js', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(data)
			})
				.then(response => response.json())
				.then(successCallback)
				.catch(errorCallback);
		},
		addToCartForm: function (form, successCallback, errorCallback) {
			$.ajax({
				url: "/cart/add.js",
				dataType: "json",
				type: "post",
				data: form.serialize(),
				success: (res) => successCallback(res),
				error: errorCallback
			})

			document.dispatchEvent(new CustomEvent('ajaxProduct:added', {}))
		},
		updateQuantity: function (line, quantity, successCallback, errorCallback) {
			const data = {
				line: line,
				quantity: quantity
			};

			fetch('/cart/change.js', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(data)
			})
				.then(response => response.json())
				.then(successCallback)
				.catch(errorCallback);
		},
		removeFromCart: function (line, successCallback, errorCallback) {
			const data = {
				line: line
			};

			fetch('/cart/change.js', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(data)
			})
				.then(response => response.json())
				.then(successCallback)
				.catch(errorCallback);
		},
		getShippingRates: function (data, successCallback, errorCallback) {
			fetch('/cart/shipping_rates.json?shipping_address[zip]=' + data.zip + '&shipping_address[country]=' + data.country + '&shipping_address[province]=' + data.province, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json'
				}
			})
				.then(async response => {
					if (response.ok) {
						return response.json();
					} else {
						const customError = new Error('Something went wrong');
						customError.data = await response.json();

						throw customError;
					}
				})
				.then(successCallback)
				.catch(errorCallback);
		}
	}


	/* 
		Global cookie banner
	*/
	function init_cookie_banner() {
		// shopify native cookie banner is recommended in Europe, only show this as a fallback for other regions
		if (theme.customerCountry.continent == "Europe") {
			return;
		}

		if (typeof (Storage) === "undefined") {
			return;
		}

		const COOKIE_BANNER_KEY = 'ZS-cookie-notice';
		const COOKIE_BANNER_SECTION = document.querySelector('.cookie-banner-section');
		const COOKIE_CLOSE_BTN = document.querySelector('.cookie-banner-section #ck-close-btn');
		let cookie_status = JSON.parse(window.localStorage.getItem(COOKIE_BANNER_KEY));
		const ADMIN_MODIFIER = document.querySelector('.cookie-banner-section.is_admin');

		if ((typeof COOKIE_BANNER_SECTION === 'undefined' || COOKIE_BANNER_SECTION === null) || (typeof COOKIE_CLOSE_BTN === 'undefined' || COOKIE_CLOSE_BTN === null)) {
			return;
		}

		// Close cookie banner event
		COOKIE_CLOSE_BTN.addEventListener('click', function (e) {
			e.preventDefault();

			window.localStorage.setItem(COOKIE_BANNER_KEY, 1);

			if (!COOKIE_BANNER_SECTION.classList.contains('hidden')) {
				COOKIE_BANNER_SECTION.classList.add('hidden');
			}
		});

		// Show always in admin mode
		if (ADMIN_MODIFIER !== null) {
			COOKIE_BANNER_SECTION.classList.remove('hidden');
			return;
		}

		if (cookie_status === null || cookie_status === 0) {
			// First time showing cookie banner
			show_cookie_banner();

		} else {
			// Not the first time showing cookie banner
		}


		function show_cookie_banner() {
			if (COOKIE_BANNER_SECTION.classList.contains('hidden')) {
				COOKIE_BANNER_SECTION.classList.remove('hidden');
			}
		}
	}
	init_cookie_banner();

})();